<app-mcl-wrapper>
    <app-mcl-header logosource="assets/theme/mclane/img/Mclanewebwhite.png">
        <div class="buttonGroup">
            <app-menu></app-menu>
        </div>
    </app-mcl-header>
    <app-mcl-menudrawer class="drawerContainer"   [titleHeader]="'Welcome to the Mclane Connect Portal'" >
        <router-outlet ></router-outlet>
    </app-mcl-menudrawer>
    <app-mcl-footer class="gridfooter">
        <div class="insideGridFooter">
            <p class="cptext">
                © Copyright 2020 McLane Company Incorporated, Temple,TX. All Rights Reserved.
            <br>
            v{{env.version}} ({{env.buildEnv}})
            </p>
        </div>
    </app-mcl-footer >
</app-mcl-wrapper>
<div kendoDialogContainer></div>
<div class="k-i-loading" [hidden]="true"></div>
